
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Reliabletaxiserviceinpune() {



    const cardData =
    {
        keyword: 'Reliable Taxi Service in Pune',
        heading: 'Platinum24 Cabs: Reliable Taxi Service in Pune',
        headingDescription: ' Platinum24 Cabs is known for providing Reliable Taxi Service in Pune, trusted by families, corporate travelers, and tourists alike. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures safe, clean, and comfortable travel for both local and outstation trips. With professional chauffeurs, punctual pickups, and transparent pricing, we guarantee stress-free rides across Pune and beyond. Whether you need a quick city drop, an airport transfer, or a long-distance journey, Platinum24 Cabs delivers dependable service 24/7, making us the preferred choice for reliable taxi services in Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. Once the seat of the Maratha Empire, it showcases grand gateways, fountains, and gardens. Though partially destroyed by fire in 1828, its ruins still narrate tales of Bajirao and Mastani. The evening light-and-sound show recreates Maratha history. Tourists love exploring its majestic corridors and courtyards. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument with Italian arches and sprawling gardens. It is historically significant as Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. The palace houses a museum displaying Gandhi’s personal items and photographs. Its calm ambiance attracts history and peace seekers. The palace is also a memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s historic gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. The fort sits atop a hill, offering trekking trails and panoramic views of the Sahyadris. Visitors explore bastions, temples, and memorials that echo Maratha valor. Monsoon adds mist and waterfalls, enhancing its beauty. Local villagers serve rustic delicacies like pithla-bhakri at the top. Sinhagad is Pune’s perfect blend of history and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous shrine dedicated to Lord Ganesha. The magnificent idol is adorned with gold and ornaments, attracting devotees year-round. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. It is also known for charitable and cultural initiatives. The vibrant spiritual aura makes it a must-visit. Dagdusheth Temple is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is dedicated to Lord Shiva. It features rock-cut architecture with massive stone pillars, a sanctum, and a Nandi mandapa. Located in the city center, it offers a peaceful retreat from urban life. Evening prayers and chants create a mystical ambiance. Its ancient carvings reflect early Indian craftsmanship. Pataleshwar is Pune’s hidden spiritual heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a cultural treasure showcasing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, musical instruments, sculptures, and daily-use antiques. The recreated Mastani Mahal is the highlight for visitors. History lovers and students find it fascinating and educational. The museum preserves centuries of Indian culture and traditions. It is Pune’s proud showcase of heritage and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers a panoramic view of the city. At the hilltop stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the temple, making it a mix of devotion and adventure. The site also houses smaller shrines and a museum. Sunrise and sunset views are mesmerizing from here. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for spirituality and wellness. Spread across lush gardens, it attracts seekers from around the world. The ashram offers meditation, yoga, and personal growth workshops. Japanese Zen gardens and peaceful meditation halls add to its charm. Visitors experience rejuvenation and mindfulness here. Osho Ashram is Pune’s international wellness destination."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and lush green lawns. Families enjoy peaceful walks, photography, and picnics here. The garden symbolizes Indo-Japanese cultural friendship. Seasonal flowers and manicured spaces attract nature lovers. Pu La Deshpande Garden is Pune’s green oasis of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend destination near Pune. It supplies water to the city while offering scenic views of hills and flowing waters. Monsoon transforms it into a picturesque spot with overflowing streams. Street vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],



       "services": [
    {
      "name": "Reliable Taxi Pune",
      "description": "Book a reliable taxi in Pune for local, airport, and outstation travel. Our service guarantees punctual pickups, verified drivers, and well-maintained cars. Whether it’s a daily commute or a last-minute ride, you can count on us for consistent and safe service across Pune city."
    },
    {
      "name": "Trusted Taxi Service Pune",
      "description": "Experience peace of mind with our trusted taxi service in Pune. Backed by strong customer ratings and professional drivers, we offer quality cab services 24/7. Our vehicles are regularly sanitized and come with GPS tracking to ensure safety and reliability."
    },
    {
      "name": "Best Taxi Service Pune",
      "description": "Voted as one of the best taxi services in Pune, we provide timely, affordable, and comfortable travel options for all types of journeys. Choose from hatchbacks, sedans, and SUVs with transparent fares and round-the-clock customer assistance."
    },
    {
      "name": "Pune Reliable Cab Service",
      "description": "Our reliable cab service in Pune is ideal for office travel, family outings, airport transfers, and intercity rides. All drivers are background-verified, and vehicles are equipped with AC, music system, and clean interiors to enhance your travel experience."
    },
    {
      "name": "Pune Trusted Cab Provider",
      "description": "Hire cabs from Pune’s most trusted provider offering consistent quality, prompt communication, and safety-first vehicles. We offer custom travel solutions for both individuals and businesses, backed by professional driver support."
    },
    {
      "name": "Reliable Cab Booking Pune",
      "description": "Book reliable cabs in Pune online or via phone. We ensure timely pickups, accurate fare estimation, and secure rides with experienced drivers. Whether you're headed to a local destination or an outstation location, your trip is in safe hands."
    },
    {
      "name": "Affordable Reliable Taxi Pune",
      "description": "Enjoy affordable and reliable taxi services in Pune without compromising on comfort or safety. Transparent pricing, zero cancellation fees, and a range of vehicle choices make us a preferred travel partner for thousands of happy riders."
    },
    {
      "name": "Pune Taxi with Good Reviews",
      "description": "Ride with a taxi service in Pune trusted by real customers. We maintain a 4.8+ star average rating for professionalism, vehicle hygiene, and timely arrivals. Read user reviews and experience our top-rated service firsthand."
    },
    {
      "name": "24x7 Reliable Taxi Pune",
      "description": "Need a cab at odd hours? Our 24x7 reliable taxi service in Pune ensures safe, on-demand rides any time of the day or night. Perfect for early morning airport drops, late-night office pickups, or emergency travel needs."
    },
    {
      "name": "Reliable Airport Taxi Pune",
      "description": "Book reliable airport taxis in Pune for both pickup and drop. We track your flight for timely coordination and offer seamless rides with courteous drivers and clean vehicles. Advance and instant bookings supported."
    },
    {
      "name": "Reliable Outstation Taxi Pune",
      "description": "Planning a weekend getaway or business trip? Our reliable outstation taxi service in Pune ensures smooth intercity travel with fixed fares, vetted drivers, and well-maintained vehicles equipped for long-distance comfort."
    },
    {
      "name": "Pune Taxi Service with Verified Drivers",
      "description": "All our Pune taxi drivers undergo thorough background verification, training, and etiquette assessments. Your safety and satisfaction are our top priority on every ride, whether local or long-distance."
    },
    {
      "name": "Reliable Local Taxi Pune",
      "description": "Get around Pune with our reliable local taxi service that covers every major area including Kothrud, Baner, Hinjewadi, Viman Nagar, and more. Perfect for daily errands, shopping, school runs, or client meetings."
    },
    {
      "name": "Pune Reliable Cab with AC",
      "description": "Travel in comfort with our reliable AC cabs in Pune. From compact sedans to spacious SUVs, all our vehicles come with air-conditioning and clean interiors to provide a cool, stress-free journey even in peak summer."
    },
    {
      "name": "Reliable Taxi Service Near Me Pune",
      "description": "Looking for a reliable taxi near your location in Pune? We offer GPS-enabled cab tracking and nearest driver assignment so you can get a ride quickly, safely, and affordably. Available across all Pune neighborhoods."
    }
  ],
  "tableData": [
    ["Reliable Taxi Pune", "Trusted Taxi Service Pune"],
    ["Best Taxi Service Pune", "Pune Reliable Cab Service"],
    ["Pune Trusted Cab Provider", "Reliable Cab Booking Pune"],
    ["Affordable Reliable Taxi Pune", "Pune Taxi with Good Reviews"],
    ["24x7 Reliable Taxi Pune", "Reliable Airport Taxi Pune"],
    ["Reliable Outstation Taxi Pune", "Pune Taxi Service with Verified Drivers"],
    ["Reliable Local Taxi Pune", "Pune Reliable Cab with AC"],
    ["Reliable Taxi Service Near Me Pune", "—"]
  ],


        "whychoose": [
    {
      "WhyChooseheading": "Reliable Taxi Service in Pune for All Your Travel Needs",
      "WhyChoosedescription": "Platinum24 Cabs offers dependable taxi services across Pune for local, outstation, and airport travel."
    },
    {
      "WhyChooseheading": "Prompt Pickups and On-Time Drop-offs",
      "WhyChoosedescription": "Our professional drivers ensure timely service so you never miss a meeting, flight, or event."
    },
    {
      "WhyChooseheading": "Clean, Comfortable, and Well-Maintained Fleet",
      "WhyChoosedescription": "Travel in sanitized, air-conditioned taxis that prioritize your safety and comfort."
    },
    {
      "WhyChooseheading": "Experienced and Verified Drivers for Safe Travel",
      "WhyChoosedescription": "All our drivers are background-checked and trained to provide a smooth and secure ride experience."
    },
    {
      "WhyChooseheading": "24/7 Availability Across Pune",
      "WhyChoosedescription": "Book a taxi anytime, anywhere in Pune with our always-on taxi service."
    },
    {
      "WhyChooseheading": "Easy Online Booking and Real-Time Cab Tracking",
      "WhyChoosedescription": "Use our app or website to book instantly and track your ride live for full peace of mind."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy fair, upfront rates that include fuel, tolls, and driver allowances—no surprises."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Match Your Needs",
      "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or premium cars depending on your travel requirements."
    }
  ]






































    }


const faqData = [
    {
        question: 'Is Platinum24 Cabs a reliable taxi service in Pune?',
        answer: 'Yes, Platinum24 Cabs is known for offering highly reliable, safe, and professional taxi services across Pune and surrounding areas.',
    },
    {
        question: 'How do I book a reliable taxi in Pune with Platinum24 Cabs?',
        answer: 'You can book a taxi easily through our website, mobile app, or by contacting our dedicated customer support team.',
    },
    {
        question: 'What types of taxi services are available in Pune through Platinum24 Cabs?',
        answer: 'We offer a variety of taxi services in Pune including local travel, airport transfers, outstation trips, and hourly rentals.',
    },
    {
        question: 'Are the drivers with Platinum24 Cabs professional and background-checked?',
        answer: 'Yes, all our drivers are professionally trained, background-verified, and experienced to ensure a safe and pleasant journey.',
    },
    {
        question: 'Can I rely on Platinum24 Cabs for on-time pickups in Pune?',
        answer: 'Absolutely! We pride ourselves on punctual service and always strive to ensure timely pickups and drop-offs.',
    },
    {
        question: 'Do you offer taxi services in all areas of Pune?',
        answer: 'Yes, we cover all major areas of Pune including Hinjewadi, Kharadi, Viman Nagar, Baner, Hadapsar, and more.',
    },
    {
        question: 'Is the taxi fare transparent with no hidden charges?',
        answer: 'Yes, our pricing is fully transparent. You receive an upfront fare estimate, and there are no hidden charges.',
    },
    {
        question: 'Are your taxis regularly maintained and clean?',
        answer: 'All our vehicles are well-maintained, sanitized regularly, and undergo routine checks to ensure comfort and safety.',
    },
    {
        question: 'Can I schedule a taxi in advance in Pune?',
        answer: 'Yes, we allow you to pre-book your taxi ride for a later time or date as per your convenience.',
    },
    {
        question: 'Does Platinum24 Cabs offer 24/7 reliable taxi service in Pune?',
        answer: 'Yes, our taxi services in Pune are available 24/7 for your convenience, whether it’s day or night.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ramesh Kadam',
        feedback: 'Platinum24 Cabs is my go-to taxi service in Pune. Always on time, clean cars, and polite drivers.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Neha Kulkarni',
        feedback: 'Very reliable service. I’ve used their cabs multiple times in Pune and never had a single issue.',
        rating: 5,
    },
];
















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const reliableTaxiPuneSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable Taxi Service in Pune offering trusted, affordable, and 24x7 taxi booking with verified drivers. Book your trusted cab with Platinum24 Cabs today.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "telephone": "+91-XXXXXXXXXX",
  "serviceType": [
    "Reliable Taxi Pune",
    "Trusted Taxi Service Pune",
    "Best Taxi Service Pune",
    "Pune Reliable Cab Service",
    "Reliable Airport Taxi Pune",
    "Reliable Outstation Taxi Pune",
    "Reliable Local Taxi Pune"
  ]
};






    return (
        <div>
<Helmet>
  <title>Reliable Taxi Service in Pune | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Reliable Taxi Service in Pune offering trusted, affordable, and 24x7 taxi booking with verified drivers. Book your trusted cab with Platinum24 Cabs today."
  />
  <meta
    name="keywords"
    content="Reliable Taxi Pune, Trusted Taxi Service Pune, Best Taxi Service Pune, Pune Reliable Cab Service, Pune Trusted Cab Provider, Reliable Cab Booking Pune, Affordable Reliable Taxi Pune, Pune Taxi with Good Reviews, 24x7 Reliable Taxi Pune, Reliable Airport Taxi Pune, Reliable Outstation Taxi Pune, Pune Taxi Service with Verified Drivers, Reliable Local Taxi Pune, Pune Reliable Cab with AC, Reliable Taxi Service Near Me Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(reliableTaxiPuneSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/44.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Reliabletaxiserviceinpune;